export default "__VITE_ASSET__ob27rJjq__"